import { ChangeEvent } from "react";

import { Select, SelectEvent } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ReligiousAndMinorityInstitutionsDto } from "../../../../models/Institution/ReligiousAndMinorityInstitutionsDto";

interface IProps {
  selectedMinoritySchoolId: number | null;
  handleMinorityReligiousSchoolChange: (
    e: ChangeEvent<SelectEvent>,
    type: "minority" | "religious"
  ) => void;
  selectedReligiousSchoolId: number | null;
  religiousAndMinorityInstitutions?: ReligiousAndMinorityInstitutionsDto;
}

export const MinorityReligiousSelects = ({
  selectedMinoritySchoolId,
  handleMinorityReligiousSchoolChange,
  selectedReligiousSchoolId,
  religiousAndMinorityInstitutions,
}: IProps) => {
  const { t } = useTranslation();

  const { minorityInstitutions, religiousInstitutions } =
    religiousAndMinorityInstitutions ?? {};

  return (
    <>
      {!!minorityInstitutions?.length && (
        <Row>
          <Col md={6}>
            <Select
              label={t("common.institutionDetails.nationalMinoritySchool")}
              value={selectedMinoritySchoolId}
              onChange={(e) =>
                handleMinorityReligiousSchoolChange(e, "minority")
              }
              selectData={codeBookToSelectData(minorityInstitutions)}
              required
            />
          </Col>
        </Row>
      )}
      {!!religiousInstitutions?.length && (
        <Row>
          <Col md={6}>
            <Select
              label={t("common.institutionDetails.religiousSchool")}
              value={selectedReligiousSchoolId}
              onChange={(e) =>
                handleMinorityReligiousSchoolChange(e, "religious")
              }
              selectData={codeBookToSelectData(religiousInstitutions)}
              required
            />
          </Col>
        </Row>
      )}
    </>
  );
};
